import React from 'react';
import { OriginatingTransaction } from '../../../../types/amr-pipeline/models/OriginatingTransaction';
import { commonPipelineColumns } from './columns/common-columns';
import { PipelineList } from '../PipelineList';
import { AmrTransaction } from '../../../../types/amr-pipeline/models/AmrTransaction';
import { UserConfigColumn } from '../../../../types/user-config/UserConfigColumn';
import { PipelineEmptyPlaceholder } from '../PipelineEmptyPlaceholder';
import { user } from '../../../../user';
import { roles } from '../../../../constants';
import classNames from 'classnames';

interface Props {
    columnsConfig: UserConfigColumn[];
    transactions: (OriginatingTransaction | AmrTransaction)[];
    onRedirect: () => void;
}

export const DealView = ({ columnsConfig, transactions, onRedirect }: Props) => {
    const isButtonAvailable = user.hasRoles(
        ...roles.getAllRolesExclude(
            ...roles.admin(),
            roles.DataEntry,
            roles.Viewer,
            roles.Media,
        )
    );
    
    return transactions.length
        ? <PipelineList
            className={classNames('pipeline-list-deals', { 'pipeline-list-deals-with-button': isButtonAvailable })}
            columns={commonPipelineColumns(columnsConfig)}
            dataItems={transactions}
        />
        : <PipelineEmptyPlaceholder onRedirect={onRedirect} />
};
